<div style="margin-left: 15px; display: inline;block-size: 10%;">
    <div class="col-12 col-md-12">   
      <div class="row">
      <div class="col-md-6"  style="padding: 0px;">
        <h2 class="ng-binding" style="font-size: 30px; margin: 0px;">Stock Breakdown</h2>
      </div>
        <div class="col-md-6" style="text-align: right;padding: 0px;">  
        <span class="btn-blue">
          <i aria-hidden="true" class="fa fa-file-excel-o" title="Export to Excel" style="font-size: 16px;
          cursor: pointer; line-height: 20px; text-decoration: none;
           position: relative; padding: 5px 4px;"></i></span> 
           <span class="btn-blue" style="font-size: 13px; display: inline-block; padding: 4px 12px 4px; font-size: 15px; margin-left: 10px; float: right;" (click)="backBtn()">
            <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Return to Inventory
          </span>
          </div>
        </div> 
      </div>
    </div> 
   <div class="sahil">
    <div class="row">
      <div class="col-md-4">
        <span class="label orangeBadge fntSz"
        style="cursor:pointer;margin-left:5px;"><span style="margin-right:5px"><i class="fa fa-square"
            aria-hidden="true"></i></span> <span>Products</span></span>
      <span class="label yellowBadge fntSz"
        style="cursor:pointer;margin-left:5px;"><span style="margin-right:5px"><i class="fa fa-square"
            aria-hidden="true"></i></span> <span>Materials</span></span>
      <span class="label greenBadge fntSz"
            style="cursor:pointer;margin-left:5px;"><span>All</span></span> 
          </div>
      <div class="col-md-4">
        <span class="label darkBlueBadge fntSz" style="cursor:pointer;">
           <label
          style="margin-bottom: 0px;"><input type="checkbox" style="position: relative;"> Show Zero Qty Items</label></span>
      </div>
      <div class="col-md-4">
        <span class="label blueBadge fntSz"
        style="cursor:pointer;margin-left:5px;"><span style="margin-right:5px"><i class="fa fa-square"
            aria-hidden="true"></i></span> <span>Active</span></span>
      <span class="label  darkBlueBadge fntSz"
        style="cursor:pointer;margin-left:5px;"><span style="margin-right:5px"><i class="fa fa-square"
            aria-hidden="true"></i></span> <span>Inactive</span></span>
      <span class="label orangeBadge fntSz"
            style="cursor:pointer;margin-left:5px;"><span>All</span></span> 
          </div>
    </div>
  </div>

  <div class="container">
    <div class="row">
      <div class="col-md-4" style="margin-left: 0px; width: 270px;" >
        <input style=" width: 270px;" class="form-control" list="cgstOut" placeholder="Select Store">
        <datalist id="cgstOut">
          <option  value="LedgerName">LedgerName</option>
          <option  value="item">item</option>
          <option  value="category">category</option>
          <option  value="room">room</option>
          <option  value="food">food</option>
        </datalist>
      </div>
      <div class="col-md-4">
        <input style=" width: 270px;" class="form-control" list="cgstOut" placeholder="Select category">
        <datalist id="cgstOut">
          <option  value="category1">category1</option>
          <option  value="category8">category</option>
          <option  value="category4">category4</option>
          <option  value="room1">room1</option>
          <option  value="food1">food</option>
        </datalist>
      </div>
      <div class="col-md-3" style="margin-left: 5px;">
        <span class="btn btn-orange" style="line-height: 33px !important;
            padding: 5px 10px; font-size: 13px !important;color:#fff; border: 1px solid #e88421;  background:#e88421;  border-radius: 25px;padding: 0px 15px;">
             <span style="margin-right: 10px;"><i aria-hidden="true" class="zmdi zmdi-search"
            style="font-size: 16px;position: relative;top: 1px;"></i>
          </span><span >Search</span></span>
      </div>
    </div>
  </div>

  <div class="wrapper" style=" overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"  #pprtable>
    <table mat-table [dataSource]="dataSource">
     
      <ng-container matColumnDef="item">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef>
          <label>Item</label>
        </th>
        <td mat-cell *matCellDef="let element"> {{element.item}} </td>
      </ng-container>
      <ng-container matColumnDef="code">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef >
          <label> Code</label>
        </th>
        <td mat-cell *matCellDef="let element">  {{element.code}}  </td>
      </ng-container>
    
      <ng-container matColumnDef="store">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef>
          <label>Store</label>
        </th>
        <td mat-cell *matCellDef="let element" >  {{element.store}} </td>
      </ng-container>

      <ng-container matColumnDef="banchno">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef>
          <label>Banch No</label>
        </th>
        <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.banchno}} </td>
      </ng-container>

      <ng-container matColumnDef="category">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef >
          <label>Category</label>
        </th>
        <td mat-cell *matCellDef="let element"> {{element.category}} </td>
      </ng-container>

      <ng-container matColumnDef="quantity">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef >
          <label>Quantity</label>
        </th>
        <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.quantity}} </td>
      </ng-container>

      <ng-container matColumnDef="unit">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef>
          <label>Unit</label>
        </th>
        <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.unit}} </td>
      </ng-container>

      <ng-container matColumnDef="currrate">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef>
          <label>Currrate</label>
        </th>
        <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.currrate}} </td>
      </ng-container>

      <ng-container matColumnDef="listing">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef >
          <label>Listing</label>
        </th>
        <td mat-cell *matCellDef="let element"> {{element.listing}} </td>
      </ng-container>

      <ng-container matColumnDef="refresh">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef>
          <label> </label>
        </th>
        <td mat-cell *matCellDef="let element" style="width: 10px;">
          <div class="lableBtnBlue ng-scope" style="border-radius: 50%;">
            <i class="zmdi zmdi-time-restore" aria-hidden="true"></i>
        </div>
        </td>
      </ng-container>
    
      <ng-container matColumnDef="edit">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef>
          <label> </label>
        </th>
        <td mat-cell *matCellDef="let element" style="width: 10px;">
          <div class="lableBtnOrange ng-scope" style="border-radius: 50%;">
            <i class="fa fa-pencil" aria-hidden="true"></i>
        </div>
        </td>
      </ng-container>
    
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
   <!-- Angular 8 pagination -->
   <mat-paginator
        [pageSizeOptions]="[5, 10, 15]" showFirstLastButtons>
   </mat-paginator>
</div>
